module.exports = __webpack_public_path__ + "img/doctor-advice.a08591a0.png";